<div class="text-center">
    <div class="spinner-border text-light" style="width: 3rem; height: 3rem;" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
    <div class="mt-3 text-secondary text-center">
        <p>Loading</p>
    </div>
</div>